import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useUserInfor } from "../../../../Context/User";

import SpinnerComponent from "../../../../Components/Loding/Spinner";

import { ListarMotivoInadimplenciaController } from "../../../../Controllers/Cobranca/MotivoInadimplencia/MotivoInadimplenciaController";
import {
    InserirContatoNaoEfetivoController,
    ListarResultadoContatoNaoEfetivo,
} from "../../../../Controllers/Cobranca/ResultadoContato/ResultadoContatoController";
import { IMotivoInadimplencia } from "../../../../Interfaces/Cobranca/MotivoInadimplencia/MotivoInadimplenciaInterface";
import { IResultadoContato } from "../../../../Interfaces/Cobranca/ResultadoContato/ResultadoContatoInterface";
import { useAtedimento } from "../../../../Context/Atendimento";
import { ACESSOS } from "../../../../Routes/Acessos";
import { useHistory } from "react-router-dom";
import { SeletorMultiCasoContato } from "../SeletorMultiCasoContato";

interface IContatoNaoEfetivoProps {
    setShow: (show: boolean) => void;
}
interface IContatoNaoEfetivoForm {
    motivo_inadimplencia: number;
    resultado_contato: number;
    dt_retorno: string;
    justificativa: string;
}

export default function ContatoNaoEfetivo(
    props: IContatoNaoEfetivoProps,
    ID_CASO: number
) {
    const history = useHistory();
    const { register, formState, setValue, handleSubmit } = useForm();
    const { FL_MODO_ATENDIMENTO, goToNextAtendimento } = useAtedimento();

    const [lstIdCasoExtra, setLstIdCasoExtra] = useState<Array<number>>([]);

    const [optionsMotivoInadimplencia, setOptionsMotivoInadimplencia] =
        useState<Array<IMotivoInadimplencia>>();
    const [optionsResultadoContato, setOptionsResultadoContato] =
        useState<Array<IResultadoContato>>();
    const { HR_INICIO, HR_FIM } =
        useUserInfor().Config.ConfigVersaoWebServiceDTO;
    const [SpinnerShow, setSpinnerShow] = useState(false);
    const [ButtonSpinner, setButtonSpinner] = useState(false);

    const resultadoContadoNaoEfetivo = optionsResultadoContato?.filter(
        (option) => option.FL_ATIVO
    );

    useEffect(() => {
        ListarMotivoInadimplenciaController().then((res) => {
            setOptionsMotivoInadimplencia(res);
        });
        ListarResultadoContatoNaoEfetivo().then((res) => {
            setOptionsResultadoContato(res);
        });
    }, []);

    function getTempoRetorno(horas: number) {
        const data = new Date();
        while (horas > 0) {
            const horasUteis =
                Number.parseInt(HR_FIM.split(":")[0]) - data.getHours();
            if (horas > horasUteis) {
                horas -= horasUteis;
                data.setDate(data.getDate() + 1);
                data.setHours(
                    Number.parseInt(HR_INICIO.split(":")[0]),
                    Number.parseInt(HR_INICIO.split(":")[1])
                );
            } else {
                data.setHours(data.getHours() + horas);
                horas = 0;
            }
        }
        //retira offset de fuso horário
        data.setMinutes(data.getMinutes() - data.getTimezoneOffset());
        return data.toISOString();
    }

    function handleContatoNaoEfetivoFormSubmit(
        formData: IContatoNaoEfetivoForm
    ) {
        setButtonSpinner(true);
        InserirContatoNaoEfetivoController({
            ID_CASO_COBRANCA_RESULTADO_CONTATO: formData.resultado_contato,
            ID_CASO_COBRANCA_MOTVO_INADIMPLENCIA: formData.motivo_inadimplencia,
            ID_CASOs: [ID_CASO, ...lstIdCasoExtra],
            DT_RETORNO: formData.dt_retorno,
            Justificativa: formData.justificativa,
        })
            .then(() => {
                setButtonSpinner(true);
                if (FL_MODO_ATENDIMENTO) {
                    setSpinnerShow(true);
                    goToNextAtendimento()
                        .then(() => {
                            props.setShow(false);
                        })
                        .finally(() => {
                            setSpinnerShow(false);
                        });
                } else {
                    setButtonSpinner(false);
                    props.setShow(false);
                    history.push(
                        ACESSOS.COBRANCA.TELAS.GESTAO_ATENDIMENTOS.DS_PATH
                    );
                }
            })
            .catch(() => {
                setButtonSpinner(false);
            });
    }

    if (optionsMotivoInadimplencia && optionsResultadoContato && !SpinnerShow) {
        return (
            <form onSubmit={handleSubmit(handleContatoNaoEfetivoFormSubmit)}>
                <div className="col-12 p-0">
                    <label htmlFor="motivo_inadimplencia">
                        Motivo de Inadimplência
                    </label>
                    <select
                        name="motivo_inadimplencia"
                        className={`form-control placeholder-dark-50 ${
                            formState.errors.motivo_inadimplencia &&
                            "is-invalid"
                        }`}
                        ref={register({
                            valueAsNumber: true,
                            required: "Insira o motivo de inadimplência",
                        })}
                    >
                        <option></option>
                        {optionsMotivoInadimplencia.map((motivo) => (
                            <option
                                key={
                                    motivo.ID_CASO_COBRANCA_MOTIVO_INADIMPLENCIA
                                }
                                value={
                                    motivo.ID_CASO_COBRANCA_MOTIVO_INADIMPLENCIA
                                }
                            >
                                {motivo.DS_MOTIVO_INADIMPLENCIA}
                            </option>
                        ))}
                    </select>
                    <div className="invalid-feedback">
                        {formState.errors.motivo_inadimplencia
                            ? formState.errors.motivo_inadimplencia.message
                            : ""}
                    </div>
                </div>
                <div className="col-12 p-0 mt-4">
                    <label htmlFor="resultado_contato">
                        Resultado de Contato
                    </label>
                    <select
                        name="resultado_contato"
                        className={`form-control placeholder-dark-50 ${
                            formState.errors.resultado_contato && "is-invalid"
                        }`}
                        ref={register({
                            valueAsNumber: true,
                            required: "Insira o resultado do contato",
                        })}
                        onChange={(e) => {
                            if (e.target.value) {
                                const horas =
                                    optionsResultadoContato.find(
                                        (x) =>
                                            x.ID_CASO_COBRANCA_RESULTADO_CONTATO ===
                                            Number.parseInt(e.target.value)
                                    )?.NR_TEMPO_RETORNO_FILA || 0;
                                const tempoRetorno = getTempoRetorno(horas);
                                setValue(
                                    "dt_retorno",
                                    tempoRetorno.substring(
                                        0,
                                        tempoRetorno.length - 8
                                    )
                                ); // -8 tira a parte desnessessária da string (segundos)
                            }
                        }}
                    >
                        <option></option>
                        {resultadoContadoNaoEfetivo?.map((resultado, index) => (
                            <option
                                key={index}
                                value={
                                    resultado.ID_CASO_COBRANCA_RESULTADO_CONTATO
                                }
                            >
                                {resultado.DS_RESULTADO_CONTATO}
                            </option>
                        ))}
                    </select>
                    <div className="invalid-feedback">
                        {formState.errors.resultado_contato
                            ? formState.errors.resultado_contato.message
                            : ""}
                    </div>
                </div>
                <div className="col-12 p-0 mt-4">
                    <label htmlFor="">Tempo de Retorno</label>
                    <input
                        type="datetime-local"
                        className="form-control"
                        ref={register()}
                        name="dt_retorno"
                    />
                </div>
                <textarea
                    name="justificativa"
                    className={`form-control placeholder-dark-45 mt-5 mh-100 ${
                        formState.errors.justificativa && "is-invalid"
                    }`}
                    placeholder="Justificativa"
                    style={{ minHeight: "40px", height: "150px" }}
                    ref={register({
                        required: "Insira a justificativa",
                    })}
                />
                <div className="invalid-feedback">
                    {formState.errors.justificativa
                        ? formState.errors.justificativa.message
                        : ""}
                </div>

                <SeletorMultiCasoContato
                    onChange={setLstIdCasoExtra}
                    ID_CASO={ID_CASO}
                />

                {ButtonSpinner ? (
                    <button
                        type="button"
                        className="btn btn-outline-success font-weight-bold d-flex col-12 justify-content-center mt-5"
                        disabled
                    >
                        <div className="row px-4">
                            <div className="loading-component">
                                <div
                                    className="spinner-border spinner-border-sm text-light"
                                    role="status"
                                >
                                    <span className="sr-only">
                                        Carregando...
                                    </span>
                                </div>
                            </div>
                            <div className="ml-2">Confirmar Contato</div>
                        </div>
                    </button>
                ) : (
                    <button className="btn btn-outline-success font-weight-bold d-flex col-12 justify-content-center mt-5">
                        Confirmar Contato
                    </button>
                )}
            </form>
        );
    } else if (SpinnerShow) {
        return (
            <div className="mt-4">
                <SpinnerComponent />
                <div className="d-flex justify-content-center align-items-center mt-4 mr-4">
                    Buscando Próximo Atendimento
                </div>
            </div>
        );
    } else {
        return <SpinnerComponent />;
    }
}
